// Account Payable Actions

import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get accountPayableList from backend then update accountPayableList in vuex store ***** //
export const fetchAccountPayableList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get('account_payable_index', { params: params })
    commit('setAccountPayableList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch accountPayableInfo from backend ***** //
export const fetchAccountPayableInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`account_payable_show/${payload}`)
    commit('setAccountPayableInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch accountPayableBalanceDetails from backend ***** //
export const fetchAccountPayableBalanceDetails = async ({ commit }) => {
  try {
    const result = await Axios.get(`account_payable_balance_details`)
    commit('setAccountPayableBalanceDetails', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}
